/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// styles
import injectSheet from 'react-jss';
import styles from './sectioncard_styles';



/* ========== ~~~~~~~~~~ EXPANDABLE SECTION - SECTION CARD ~~~~~~~~~~ ========== */
const SectionCard = (props) => {
  const { title } = props
  return <div className={`sectioncard ${props.classes.sectioncard} ${props.klass}`}>
    {title && <h2>{title}</h2>}
    {props.children}
  </div>
};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SectionCard);
